import Validator from 'validatorjs';
import React, { Component } from 'react';
import { Col, Row } from 'react-bootstrap';

import { FormControl } from '../../../../../facturotopia';
import ComercioExteriorDomicilioForm from './ComercioExteriorDomicilioForm';

class ComercioExteriorEmisorForm extends Component {
  state = {};

  constructor(props) {
    super(props);

    const { data = {} } = props;
    const { Emisor = {} } = data;

    this.state = {
      data: { ...Emisor },
      isValid: false,
      isValidAddress: false,
      validator: new Validator({}, this.rules({})),
    };
  }

  rules(data) {
    return {
      'Curp': ['string', 'size:18', 'regex:/^[A-Z][AEIOUX][A-Z]{2}[0-9]{2}(0[1-9]|1[012])(0[1-9]|[12][0-9]|3[01])[MH]([ABCMTZ]S|[BCJMOT]C|[CNPST]L|[GNQ]T|[GQS]R|C[MH]|[MY]N|[DH]G|NE|VZ|DF|SP)[BCDFGHJ-NP-TV-Z]{3}[0-9A-Z][0-9]$/'],
    }
  }

  handleOnChange = (value) => {
    let data = {
      ...this.state.data,
      ...value
    }

    const validator = this.validate(data);
    const isValid = validator.passes() && this.state.isValidAddress;
    const event = { isValid, name: 'emisor' };
    const newData = {
      ...this.props.data,
      Emisor: data
    }

    this.props.onChange(newData, event);

    this.setState({
      data,
      isValid: isValid
    })
  }

  validate(data) {
    const validator = new Validator(data, this.rules(data));

    validator.check();

    this.setState({
      validator
    });

    return validator;
  }

  handleOnDomicilioDataChange = (event) => {
    const data = {
      ...this.state.data,
      Domicilio: event.data,
    }

    this.setState({
      isValidAddress: event.isValid,
    }, () => {
      this.handleOnChange(data);
    });
  }

  render() {
    const { data = {} } = this.state;

    const rules = this.rules(data);

    return (
      <div className="pb-4">
        <div>
          <strong className="text-black text-upper">Emisor</strong>
        </div>

        <div className="section pt-2">

          <Row>
            <Col sm md={ 4 }>
              <FormControl type="text"
                label="Curp"
                name="Curp"
                placeholder=""
                help=""
                casing={ 'upper' }
                minLength="1"
                maxLength="50"
                rules={ rules.Curp }
                value={ data.Curp }
                onChange={ this.handleOnChange }
              />
            </Col>
          </Row>

          <Row>
            <Col>
              <strong>Domicilio</strong>
            </Col>
          </Row>

          <ComercioExteriorDomicilioForm
            required
            data={ data.Domicilio || {} }
            onFormDataChange={ this.handleOnDomicilioDataChange }
          />
        </div>
      </div>
    )
  }
}

export default ComercioExteriorEmisorForm;